import React, { useEffect, useState } from "react";
import { Grid, Typography, Tooltip } from "@mui/material"; // Import Tooltip from Material-UI
import "../../assets/css/accountmetrics.scss";
import {ReactComponent as InfoOutlineIcon} from "../../assets/icons/InfoOutlineIcon.svg";
import Title from "./title";
import ProgressBar from "@ramonak/react-progress-bar";

const StatFormatter = (status) => {
  const classList =
    String(status).toLowerCase() === "success"
      ? "StatusPassed"
      : String(status).toLowerCase() === "failed"
      ? "StatusFailed"
      : String(status).toLowerCase() === "in progress"
      ? "StatusInProgress"
      : "";

  return <div className={`AMStat ${classList}`}>{status}</div>;
};


const calculateRemainingTime = () => {
  const now = new Date();

  // Set target time to 00:00:00 GMT+2 (Convert to UTC → 22:00 UTC)
  const target = new Date(now);
  target.setUTCHours(21, 0, 0, 0);

  // If the current time is already past midnight, set the target to the next day
  if (now >= target) {
    target.setUTCDate(target.getUTCDate() + 1);
  }

  return target - now;
};

const formatTime = (time) => {
  const hours = Math.floor(time / (60 * 60 * 1000));
  const minutes = Math.floor((time % (60 * 60 * 1000)) / (60 * 1000));
  const seconds = Math.floor((time % (60 * 1000)) / 1000);

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
};

const AMDropdown = ({ desc, head, remaining, result, status, targetValue, consistency, showInfoIcon, onInfoClick }) => {
  console.log(remaining,'remaining')
  const [descOpen, setDescOpen] = useState(false);
  
  const handleDescToggle = () => setDescOpen((prevState) => !prevState);
  const [timeRemaining, setTimeRemaining] = useState(calculateRemainingTime());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeRemaining(calculateRemainingTime());
    }, 1000);

    return () => clearInterval(interval);
  }, []);
  // Parse and clean the input values
  const cleanedTargetValue =
    parseFloat((targetValue || "0").replace(/[$,]/g, "")) || 0;

  let cleanedRemaining =
    parseFloat((remaining || "0").replace(/[$,]/g, "")) || 0;
  if (cleanedRemaining < 0) cleanedRemaining = cleanedTargetValue;

  // Calculate the completed and max values
  const completedValue = Math.max(cleanedTargetValue - cleanedRemaining, 0);
  const maxCompletedValue = Math.max(cleanedTargetValue, 0);
  // console.log(remaining,completedValue,maxCompletedValue,"remainingremaining")

  // // Debugging logs for clarity
  // console.log({
  //   cleanedTargetValue,
  //   cleanedRemaining,
  //   completedValue,
  //   maxCompletedValue,
  //   head,
  //   message: "Debug Info",
  // },"jhseruiser");

  return (
    <div
      className="DropdownBox"
      style={{ display: "flex", flexDirection: "column" }}
    >
      <div className="containerTradingObjective" onClick={handleDescToggle}>
        <div className="titleBox">
          <Title four>
            {head}
            {showInfoIcon && (
              <span 
                style={{ cursor: "pointer", marginLeft: "8px" }}
                onClick={(e) => {
                  e.stopPropagation(); // Prevent dropdown toggle
                  if (onInfoClick) onInfoClick();
                }}
              >
                <InfoOutlineIcon/>
              </span>
            )}
          </Title>
          <div className="resultDetail">
            {(desc === "Max Daily Loss" || desc === "Profit" || desc === "Max Risk Per Asset Loss") && remaining
              ? false
              : result && (
                  <div className="DropdownResult">Results: {result}</div>
                )}
                {consistency && (
                  <div className="DropdownResult" style={{ marginTop: "6px" }}>
                    Best Trading Day Profit: {consistency?.highest_profit&&consistency?.highest_profit?.toFixed(2)}{" "}
                    <Tooltip title={consistency.highest_profit_day || "No date available"} arrow placement="top">
                      <span style={{ cursor: "pointer" }}><InfoOutlineIcon/></span>
                    </Tooltip>
                  </div>
                )}
          </div>
        </div>

        <div className="timeWrapperDiv">
          {status && (
            <div className="DropdownStatus">{StatFormatter(status)}</div>
          )}
          {desc === "Max Daily Loss" && (
            <div className="timer-container timerWrapper">
              <Typography className="timer-text">
                Timer Reset In: {formatTime(timeRemaining)}
              </Typography>
            </div>
          )}
        </div>
      </div>

      {(desc === "Max Daily Loss" || desc === "Profit" || desc === "Max Risk Per Asset Loss") && (
        <Grid mt={2}>
          <ProgressBar
            height="12px"
            baseBgColor="#8F8F8F"
            bgColor={desc === "Max Risk Per Asset Loss" ? "#FD504F" : "#FDE74C"}
            labelColor="#181818"
            labelSize="10px"
            width="100%"
            className="progressBar"
            customLabel={completedValue}
            completed={desc === "Max Risk Per Asset Loss" ? maxCompletedValue : completedValue}
            maxCompleted={maxCompletedValue}
          />
          <div
            className="progressDetails"
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            {desc === "Max Risk Per Asset Loss" ? (
              <>
                <div className="DropdownResult">{targetValue}</div>
                <div className="DropdownResult" style={{ color: "#FD504F" }}>{result}</div>
              </>
            ) : (
              <>
                <div className="DropdownResult">Remaining: ${cleanedTargetValue<Number(result)?0:remaining}</div>
                <div className="DropdownResult">Max: {targetValue}</div>
              </>
            )}
          </div>
        </Grid>
      )}
    </div>
  );
};

export default AMDropdown;
